import type { ActionButton } from "@/types";

interface QuickReplyChipsProps {
  buttons: ActionButton[];
  disabled?: boolean;
  onPick: (button: ActionButton) => void;
}

/** Horizontally scrollable quick-reply chips built from guide titles. */
export function QuickReplyChips({ buttons, disabled, onPick }: QuickReplyChipsProps) {
  if (buttons.length === 0) return null;
  return (
    <fieldset
      aria-label="빠른 질문 / Quick replies"
      className="mx-auto w-full max-w-2xl border-0 p-0 px-4 pb-2"
    >
      <div className="flex gap-2 overflow-x-auto scrollbar-thin py-1">
        {buttons.map((b) => (
          <button
            key={b.guide_id}
            type="button"
            disabled={disabled}
            onClick={() => onPick(b)}
            className="shrink-0 whitespace-nowrap rounded-full border border-primary/40 bg-primary/5 px-3.5 py-1.5 text-sm text-foreground transition-colors hover:bg-primary/10 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {b.label}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
